const mutations = {
  login (state, d) {
    // data : javascript array, index: first element of JS Obj
    const index = 0
    var data = d.data[index]
    state.logged = 1
    state.loginFailed = false
    // console.log(data)
    // console.log(data.user)
    // console.log(data.userEmail)
    // console.log(data.token)
    // console.log(data.permissions)
    // console.log(data.permissionCode)
    // const user = data.user // user name
    const userId = data.id // user id
    const user = data.userEmail // user email
    const permissions = data.permissions // user name
    const token = data.token
    const userIp = data.userIp
    // const user = JSON.stringify(data.user) // user name
    // const user = JSON.stringify(data.userEmail) // user email
    // const permissions = JSON.stringify(data.permissions)
    localStorage.setItem('id', userId)
    localStorage.setItem('token', token)
    localStorage.setItem('user', user)
    localStorage.setItem('permissions', permissions)
    localStorage.setItem('userIp', userIp)
    state.token = token
    state.user = user
    state.permissions = permissions
  },
  loginWait (state, status) {
    state.loginWait = status
  },
  loginFailed (state) {
    state.loginFailed = true
  },
  logout (state) {
    state.loginWait = false
    state.loginFailed = false
    state.logged = 0
    state.user = null
    state.token = null
    state.permissions = null
    localStorage.removeItem('id')
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    localStorage.removeItem('permissions')
  },
  editUser (state, data) {
    const user = JSON.stringify(data)
    localStorage.setItem('user', user)
    state.user = user
    state.userUpdated = true
    setTimeout(() => {
      state.userUpdated = false
    }, 3000)
  },
  editPassword (state, data) {
    if (data.status === 1) {
      state.userPasswordUpdated = true
      setTimeout(() => {
        state.userPasswordUpdated = false
      }, 3000)
    } else if (data.status === -1) {
      state.userPasswordUpdateError = true
      state.userPasswordUpdateErrorMsg = data.msg
      setTimeout(() => {
        state.userPasswordUpdateError = false
      }, 3000)
    }
  },
  refreshToken (state, data) {
    const { token } = data
    localStorage.setItem('token', token)
    state.token = token
  },
}
export default mutations
